// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","302":"cbbabd4a","455":"492e6b75","578":"d08f295d","977":"042c8deb"}[chunkId] + ".chunk.js";
};